import { useTranslation } from 'react-i18next';

import { Heading1, Stack } from '@myphx-engineering/phx-design-system';

import { usePatientContext } from '../../../hooks/use-patient-context';

import { HomeMedCabCard } from './HomeMedCabCard';
import { MarketingCards } from './MarketingCards';

export const HomePage = () => {
    const { patient } = usePatientContext();
    const { t } = useTranslation();

    return (
        <Stack gap="lg">
            <Heading1>
                {t('home.welcomeUser', { name: patient?.firstName })}
            </Heading1>

            <Stack gap="xs">
                <MarketingCards />
                <HomeMedCabCard patientId={patient?.id ?? ''} />
            </Stack>
        </Stack>
    );
};
